/**
 * Movie polls
 */
const polls = () => {

  const USER_SESSION_KEY = 'biorex-user-session';
  const SCROLL_POSITION_KEY = 'biorex-voting-scroll-height';
  const VOTED_KEY_PREFIX = 'biorex-vote-';

  /**
   * Hash function
   *
   * @see https://stackoverflow.com/a/7616484
   */
  String.prototype.hashCode = function () {
    let hash = 0,
      i,
      chr;
    if (this.length === 0) return hash;
    for (i = 0; i < this.length; i++) {
      chr = this.charCodeAt(i);
      hash = (hash << 5) - hash + chr; // eslint-disable-line no-bitwise
      hash |= 0; // eslint-disable-line no-bitwise
    }
    return hash;
  };

  const updateCountdown = () => {
    const countdowns = document.querySelectorAll('.js-movie-poll-countdown');
    // loop  through countdowns
    countdowns.forEach((countdown) => {
      const countdownTime = countdown.getAttribute('data-countdown-time');
      const countdownDate = new Date(countdownTime).getTime();

      const daysEl = countdown.querySelector('.js-movie-poll-countdown-days span');
      const hoursEl = countdown.querySelector('.js-movie-poll-countdown-hours span');
      const minutesEl = countdown.querySelector('.js-movie-poll-countdown-minutes span');
      const secondsEl = countdown.querySelector('.js-movie-poll-countdown-seconds span');

      setInterval((iCountDownDate, iCountdown, iDaysEl, iHoursEl, iMinutesEl, iSecondsEl) => {
        const now = new Date().getTime();
        const distance = iCountDownDate - now;

        if (distance < 0) {
          // add timestamp to URL and reload page
          const url = new URL(window.location.href);
          url.searchParams.set('timestamp', Date.now()); // cache buster
          window.location.href = url;
          return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        iDaysEl.textContent = days;
        if (days === 1) {
          iDaysEl.parentElement.classList.add('is-one');
          iDaysEl.parentElement.classList.remove('is-many');
        } else {
          iDaysEl.parentElement.classList.add('is-many');
          iDaysEl.parentElement.classList.remove('is-one');
        }
        if ( days === 0 ) {
          iDaysEl.parentElement.classList.add('is-empty');
        }
        iHoursEl.textContent = hours;
        if (hours === 1) {
          iHoursEl.parentElement.classList.add('is-one');
          iHoursEl.parentElement.classList.remove('is-many');
        } else {
          iHoursEl.parentElement.classList.add('is-many');
          iHoursEl.parentElement.classList.remove('is-one');
        }
        if ( days === 0 && hours === 0 ) {
          iHoursEl.parentElement.classList.add('is-empty');
        }
        iMinutesEl.textContent = minutes;
        if (minutes === 1) {
          iMinutesEl.parentElement.classList.add('is-one');
          iMinutesEl.parentElement.classList.remove('is-many');
        } else {
          iMinutesEl.parentElement.classList.add('is-many');
          iMinutesEl.parentElement.classList.remove('is-one');
        }
        if ( days === 0 && hours === 0 && minutes === 0 ) {
          iMinutesEl.parentElement.classList.add('is-empty');
        }
        iSecondsEl.textContent = seconds;
        if (seconds === 1) {
          iSecondsEl.parentElement.classList.add('is-one');
          iSecondsEl.parentElement.classList.remove('is-many');
        } else {
          iSecondsEl.parentElement.classList.add('is-many');
          iSecondsEl.parentElement.classList.remove('is-one');
        }
      }, 1000, countdownDate, countdown, daysEl, hoursEl, minutesEl, secondsEl);
    });
  };

  /**
   * Get user session by timestamp, user agent and random number
  */
  const getUserSessionId = () => {
    // get existing session id from session storage
    const existingSessionId = localStorage.getItem(USER_SESSION_KEY);

    // if session id exists, return it
    if (existingSessionId) {
      return existingSessionId;
    }

    const date = new Date();
    const timestamp = date.getTime();
    const userAgent = navigator.userAgent;
    const randomNumber = Math.floor(Math.random() * 1000000000);

    // hash useragent and random number
    const hash = (userAgent + '-' + randomNumber).hashCode();

    // add random number 1-1000 to session id
    const randomNumber2 = Math.floor(Math.random() * 1000);

    const sessionId = timestamp + '-' + hash + '-' + randomNumber2;

    // save session id to session storage
    localStorage.setItem(USER_SESSION_KEY, sessionId);

    return sessionId;
  };

  const voteButtons = () => {
    const polls = document.querySelectorAll('.js-movie-polls');
    // loop through polls
    polls.forEach((poll) => {
      const buttons = poll.querySelectorAll('.js-vote-button');
      // loop through buttons
      buttons.forEach((button) => {

        const pollPostId = button.getAttribute('data-poll-id');
        const movieId = button.getAttribute('data-movie-id');

        // check if user has already voted by checking session storage
        const hasVoted = localStorage.getItem('biorex-vote-' + pollPostId);
        if (hasVoted) {
          button.disabled = true;
          if ( hasVoted == movieId ) {
            button.setAttribute('data-has-voted', 'true');
          }
        }

        button.addEventListener('click', (e) => {
          e.preventDefault();

          const otherVoteButtons = poll.querySelectorAll('.js-vote-button');
          otherVoteButtons.forEach((otherButton) => {
            otherButton.disabled = true;
          });

          const checksum = button.getAttribute('data-checksum');
          const userId = getUserSessionId();

          // create form data
          const formData = new FormData();
          formData.append('ext_id', movieId);
          formData.append('checksum', checksum);
          formData.append('session_id', userId);
          formData.append('poll_post_id', pollPostId);

          // send request
           fetch('/wp-json/biorex/rosetta/v1/voting/', {
            method: 'POST',
            body: formData
          })
            .then((response) => {
              if (response.ok) {
                button.setAttribute('data-has-voted', 'true');
                localStorage.setItem('biorex-vote-' + pollPostId, movieId);
                return response.json();
              }
              throw new Error('Network response was not ok.');
            })
            .then((data) => {
              // reload page by adding timestamp to URL
              const url = new URL(window.location.href);
              url.searchParams.set('timestamp', Date.now()); // cache buster

              // save current scroll height to session storage
              localStorage.setItem(SCROLL_POSITION_KEY, window.scrollY);
              window.location = url;
            })
            .catch((error) => {
              console.error('Error:', error);
            });
        });
      });
    });
  };

  const restoreScrollPosition = () => {
    const scrollHeight = localStorage.getItem(SCROLL_POSITION_KEY);
    if (scrollHeight) {
      window.scrollTo(0, scrollHeight);
    }
    localStorage.removeItem(SCROLL_POSITION_KEY);
  };

  const init = () => {
    restoreScrollPosition();
    updateCountdown();
    voteButtons();
  };

  init();
};
polls();
